import { render, staticRenderFns } from "./CongestionGraph.vue?vue&type=template&id=4c13a28b&"
import script from "./CongestionGraph.vue?vue&type=script&lang=ts&"
export * from "./CongestionGraph.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports